import React from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <div className="glass-panel p-6 md:p-8 rounded-2xl flex flex-col h-full border-brand-violet/15" data-id="element-393" data-mp="3b1cir79weuhk">
    <div className="flex items-center mb-4" data-id="element-394" data-mp="36z94ybzrbdt4">
      <div className="w-9 h-9 md:w-12 md:h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-violet font-serif font-bold text-sm md:text-xl border border-brand-violet/30 mr-3 md:mr-4 shrink-0 shadow-sm" data-id="element-395" data-mp="36wwefafxnv4g">
        {initials}
      </div>
      <div data-id="element-396" data-mp="2s309zmmwfmmi">
        <div className="flex text-brand-goldDark mb-1 text-[15px]" data-id="element-397" data-mp="2s39reltvolgl">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-398" data-mp="v8nad69yidgi" data-mpi={i} />)}
        </div>
        <div className="font-medium text-brand-text" data-id="element-399" data-mp="qav93lnf9ezn">{name}</div>
        <div className="text-xs text-brand-muted" data-id="element-400" data-mp="h5ornglmyga2">
          {location} {product && `— ${product}`}
        </div>
      </div>
    </div>
    <p className="text-brand-text/90 italic flex-grow text-[13px] font-serif leading-relaxed" data-id="element-401" data-mp="m6m7vnn3508x">
      "{text}"
    </p>
  </div>;
export const InitialTestimonials = () => {
  const testimonials: TestimonialProps[] = [];
  return <Section className="pt-8 pb-16" data-id="element-402" data-mp="c8oj8z1bd1fs">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-[12px]" data-id="element-403" data-mp="zw66qidjpdcy">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-404" data-mp="14u7o8yvbp4mb" data-mpi={i} />)}
      </div>
    </Section>;
};
export const MoreTestimonials = () => {
  const testimonials = [{
    initials: 'MR',
    name: 'María R.',
    location: 'Rosario',
    product: 'Vademécum + Maestría',
    text: 'Los protocolos del Vademécum me dieron la seguridad que necesitaba. Ahora entro a cada sesión sabiendo exactamente hacia dónde ir cuando el campo se detiene.'
  }, {
    initials: 'PG',
    name: 'Pablo G.',
    location: 'Buenos Aires',
    product: 'Constelador',
    text: 'Con el Protocolo de Cierre de Sesión del Vademécum, mis consultantes terminan cada proceso con una imagen clara. Eso no pasaba antes. Los procesos ahora tienen un hilo real.'
  }, {
    initials: 'SV',
    name: 'Sofía V.',
    location: 'Córdoba',
    product: 'Terapeuta Sistémica',
    text: 'La Tarjeta de Consulta Rápida es lo que más uso. En una sola hoja tengo todo lo que necesito para arrancar cada sesión con continuidad y claridad total.'
  }, {
    initials: 'RA',
    name: 'Ricardo A.',
    location: 'Mendoza',
    product: 'Constelador Familiar',
    text: 'El Bono de 100 Frases Sanadoras es un recurso que no existía en ningún lado en español. Por primera vez tengo las palabras exactas para cada momento del campo.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-405" data-mp="qttyz0apalfn">
      <div className="text-center mb-12" data-id="element-406" data-mp="quvcrcj3pm12">
        <h2 className="md:text-4xl font-display font-bold mb-4 text-[24px] text-brand-violetDark pt-[0px]" data-id="element-407" data-mp="32gw78o5mksgn">
          ❤️ MÁS TERAPEUTAS QUE YA LO TIENEN
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-[12px] max-w-4xl mx-auto" data-id="element-408" data-mp="37e5vw1l6x03f">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-409" data-mp="3ggf3ail5wdcl" data-mpi={i} />)}
      </div>
    </Section>;
};